export default __webpack_public_path__ + "static/media/D100MANC4.68c20412.pdf";